import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/slot-custom.css";
import DashboardLayout from "../layout/index";
import StepHeader from "./StepHeader";
import { toast } from "react-toastify";
import FullScreenLoader from "../FullScreenLoader";
import bookappointmenticon from "../../assets/bookappointmenticon.svg";
import nodabookmedicineiconta from "../../assets/bookmedicineicon.svg";
import booklabicon from "../../assets/booklabicon.svg";
import surgery from "../../assets/surgery.svg";
import Ambulanceicon from "../../assets/Ambulanceicon.svg";
import address from "../../assets/address.svg";

export default function BookServicescard() {
  const navigate = useNavigate();
  const location = useLocation();
  const { patientCode, patient , patientcbcode} = location.state || {};
  console.log(patientCode, patient,patientcbcode, "dxfcgvhbjn");

  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [showAppointmentSection, setShowAppointmentSection] = useState(false);

  const resolvedPatient = {
    ...patient,
    ...(patient?.patientCode ? { patientId: patient.patientCode } : {}),
  };

  return (
    <>
      {isLoggingIn && <FullScreenLoader message="" />}
      <DashboardLayout>
        <div className="min-h-screen md:pt-10 bg-white md:px-6">
          <StepHeader />

          {/* Patient Info */}
          {patient && (
            <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 rounded-full"
              style={{ background: "linear-gradient(90deg, #e8f0fb 0%, #e6f7f0 100%)", border: "1px solid #c5dcf5" }}>
              <div className="w-6 h-6 rounded-full flex items-center justify-center text-white text-[11px] font-bold flex-shrink-0"
                style={{ background: "linear-gradient(135deg, #004172, #2E7D5E)" }}>
                {(patient.firstName || "P")[0].toUpperCase()}
              </div>
              <span className="text-sm font-bold text-[#004172]">
                {[patient.firstName, patient.middleName, patient.lastName].filter(Boolean).join(" ") || "Patient"}
              </span>
              {(patient.mobile || patient.mobileNumber || patient.phoneNumber || patient.phone) && (
                <>
                  <span className="w-1 h-1 rounded-full bg-[#004172]/30" />
                  <span className="text-xs font-semibold text-[#2E7D5E]">
                    {patient.mobile || patient.mobileNumber || patient.phoneNumber || patient.phone}
                  </span>
                </>
              )}
            </div>
          )}

          {/* Service Cards Row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
            {/* Book Appointment */}
            <button
              onClick={() => setShowAppointmentSection((prev) => !prev)}
              className={`flex items-center justify-center gap-3 px-2 py-3 rounded-lg transition-colors shadow-sm border ${
                showAppointmentSection
                  ? "bg-[#004276] border-[#004276] text-white"
                  : "bg-[#F5FCFF] border-[#BCEBFE] text-gray-700 hover:bg-[#004276] hover:text-white"
              }`}
            >
              <div
                className={`p-4 rounded-full border ${
                  showAppointmentSection
                    ? "bg-white/20 border-white/40"
                    : "bg-white border-[#B6E4FF]"
                }`}
              >
                <img src={bookappointmenticon} alt="Book" className="h-6 w-6" />
              </div>
              <span className="text-sm font-semibold">Book Appointment</span>
            </button>

            {/* Buy Medicine */}
            <button
              onClick={() => {
                setShowAppointmentSection(false);
                navigate("/BookService", {
                  state: {
                    patientCode: patientCode,
                    patientName: patient.firstName,
                    patient: resolvedPatient,
                  },
                });
              }}
              className="flex items-center justify-center gap-3 bg-[#F5FCFF] border border-[#BCEBFE] text-gray-700 px-2 py-3 rounded-lg hover:bg-[#004276] hover:text-white transition-colors shadow-sm"
            >
              <div className="bg-white border border-[#B6E4FF] p-4 rounded-full">
                <img src={nodabookmedicineiconta} alt="Buy Medicine" className="h-7 w-7" />
              </div>
              <span className="text-sm font-semibold">Buy Medicine</span>
            </button>

            {/* Book Lab Test */}
            <button
              onClick={() => {
                setShowAppointmentSection(false);
                navigate("/BookService", {
                  state: {
                    patientCode: patientCode,
                    patientName: patient.firstName,
                    patient: resolvedPatient,
                  },
                });
              }}
              className="flex items-center justify-center gap-3 bg-[#F5FCFF] border border-[#BCEBFE] text-gray-700 px-2 py-3 rounded-lg hover:bg-[#004276] hover:text-white transition-colors shadow-sm"
            >
              <div className="bg-white border border-[#B6E4FF] p-4 rounded-full">
                <img src={booklabicon} alt="Lab" className="h-7 w-7" />
              </div>
              <span className="text-sm font-semibold">Book Lab Test</span>
            </button>

            {/* Book Surgery */}
            <button
              onClick={() => {
                setShowAppointmentSection(false);
                navigate("/BookService", {
                  state: {
                    patientCode: patientCode,
                    patientName: patient.firstName,
                    patient: resolvedPatient,
                  },
                });
              }}
              className="flex items-center justify-center gap-3 bg-[#F5FCFF] border border-[#BCEBFE] text-gray-700 px-2 py-3 rounded-lg hover:bg-[#004276] hover:text-white transition-colors shadow-sm"
            >
              <div className="bg-white border border-[#B6E4FF] p-4 rounded-full">
                <img src={surgery} alt="Surgery" className="h-7 w-7" />
              </div>
              <span className="text-sm font-semibold">Book Surgery</span>
            </button>

            {/* Book Ambulance */}
            <button
              onClick={() => {
                setShowAppointmentSection(false);
                navigate("/BookService", {
                  state: {
                    patientCode: patientCode,
                    patientName: patient.firstName,
                    patient: resolvedPatient,
                    openAmbulance: true,
                  },
                });
              }}
              className="relative flex flex-col items-center justify-center gap-2 bg-[#FFF0ED] border border-[#FFB4A8] text-[#C62828] px-2 py-3 rounded-lg hover:bg-gradient-to-r hover:from-[#FF6B6B] hover:to-[#C62828] hover:text-white hover:border-[#C62828] transition-colors shadow-sm group min-h-[88px]"
            >
              <span className="absolute top-2 left-2 flex items-center gap-1 text-[10px] text-[#C62828] group-hover:text-white/90 font-medium">
                <span className="w-1.5 h-1.5 rounded-full bg-[#FF3D42] shrink-0 group-hover:bg-white" />
                Available 24/7
              </span>
              <div className="flex items-center justify-center gap-3 mt-3">
                <div className="bg-white border border-[#FFCCC7] p-3 rounded-full group-hover:border-white/40">
                  <img src={Ambulanceicon} alt="Book Ambulance" className="h-7 w-7" />
                </div>
                <span className="text-sm font-semibold">Book Ambulance</span>
              </div>
            </button>

            {/* Add Address */}
            <button
              onClick={() => {
                setShowAppointmentSection(false);
                navigate("/AddAddress", {
                  state: { patientCode: patientCode },
                });
              }}
              className="flex items-center justify-center gap-3 bg-[#F5FCFF] border border-[#BCEBFE] text-gray-700 px-2 py-3 rounded-lg hover:bg-[#004276] hover:text-white transition-colors shadow-sm"
            >
              <div className="bg-white border border-[#B6E4FF] p-4 rounded-full">
                <img src={address} alt="Address" className="h-7 w-7" />
              </div>
              <span className="text-sm font-semibold">Add Address</span>
            </button>
          </div>

          {/* Inline Book an Appointment Section */}
          {showAppointmentSection && (
            <div className="mt-6 bg-gray-50 border border-gray-100 rounded-2xl p-5">
              <h2 className="text-sm font-bold text-gray-900 mb-1">Book an Appointment</h2>
              <p className="text-gray-400 text-xs mb-5">
                Choose how you'd like to book — with a hospital-empanelled doctor or refer the patient to a CureBay specialist.
              </p>

              <div className="flex gap-5 items-stretch">
                {/* Empanelled Doctors */}
                <div className="flex-1 border border-gray-200 rounded-xl p-5 flex flex-col gap-4 bg-white shadow-sm">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-[#EAF4F0] flex items-center justify-center flex-shrink-0">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="8" r="4" fill="#004172" opacity="0.7" />
                        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="#004172" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.7" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 text-sm leading-tight">Empanelled Doctors</h3>
                      <span className="inline-block bg-[#E8F5F0] text-[#2E7D5E] text-[10px] font-semibold px-2 py-0.5 rounded-full mt-1">
                        Hospital Empanelled
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-500 text-xs leading-relaxed">
                    Book an appointment with doctors registered and verified under your hospital. Quick access to your existing panel of specialists.
                  </p>
                  <ul className="space-y-2 flex-1">
                    {[
                      "In-person & video consultation",
                      "Your hospital's registered specialists",
                      "Filter by department, fee & availability",
                    ].map((item) => (
                      <li key={item} className="flex items-start gap-2 text-xs text-gray-600">
                        <svg className="mt-0.5 flex-shrink-0" width="13" height="13" viewBox="0 0 16 16" fill="none">
                          <path d="M3 8l3.5 3.5L13 5" stroke="#2E7D5E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <button
                    onClick={() =>
                      navigate("/SlotBooking", {
                        state: { patientCode: patientCode, patient: resolvedPatient },
                      })
                    }
                    className="w-full flex items-center justify-center gap-2 text-white text-xs font-semibold py-2.5 rounded-lg transition-opacity hover:opacity-90"
                    style={{ background: "linear-gradient(90deg, #004172 0%, #2E7D5E 100%)" }}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="4" width="18" height="16" rx="2" stroke="white" strokeWidth="1.8" />
                      <path d="M8 2v4M16 2v4M3 10h18" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
                    </svg>
                    Book with Empanelled Doctor
                  </button>
                </div>

                {/* OR divider */}
                <div className="flex flex-col items-center justify-center gap-2 flex-shrink-0 px-1">
                  <div className="w-px flex-1 bg-gray-200" />
                  <span className="text-[10px] font-semibold text-gray-400 border border-gray-200 rounded-full w-8 h-8 flex items-center justify-center bg-white shadow-sm">
                    OR
                  </span>
                  <div className="w-px flex-1 bg-gray-200" />
                </div>

                {/* CureBay Referral Doctors */}
                <div className="flex-1 border-2 border-[#004172] rounded-xl p-5 flex flex-col gap-4 bg-white shadow-sm">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-[#004172] flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold text-sm">CB</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 text-sm leading-tight">CureBay Referral Doctors </h3>
                      <span className="inline-block bg-[#E8F0F8] text-[#004172] text-[10px] font-semibold px-2 py-0.5 rounded-full mt-1">
                        CureBay Network
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-500 text-xs leading-relaxed">
                    Refer your patient to verified CureBay specialists across India. Access a wider network of trusted doctors for complex or specialized care.
                  </p>
                  <ul className="space-y-2 flex-1">
                    {[
                      "Verified CureBay specialist network",
                      "Filter by speciality, department & date",
                      "Seamless patient referral & tracking",
                      "10 days free follow-up with CureBay doctors",
                    ].map((item) => (
                      <li key={item} className="flex items-start gap-2 text-xs text-gray-600">
                        <svg className="mt-0.5 flex-shrink-0" width="13" height="13" viewBox="0 0 16 16" fill="none">
                          <path d="M3 8l3.5 3.5L13 5" stroke="#2E7D5E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <button
                    onClick={() =>
                      navigate("/CurebayReferralDoctors", {
                        state: { patientcbcode: patient.curebayPatientId, patient: resolvedPatient ,patientcbcode: patientcbcode},
                      })
                    }
                    className="w-full flex items-center justify-center gap-2 text-xs font-semibold py-2.5 rounded-lg border-2 border-[#004172] text-[#004172] hover:bg-[#f0f6ff] transition-colors"
                  >
                    <span className="w-2 h-2 rounded-full bg-[#2E7D5E]" />
                    Refer to CureBay Doctor
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </DashboardLayout>
    </>
  );
}
